import CronAdapter from './base';

export default class Log extends CronAdapter {
  modelNamePlural = 'logs';
}
